import React from 'react';
import ViewVideoPackageComponent from '../../../Components/VideoPackage/ViewVideoPackage';

export default function ViewVideoPackage() {
    return (
        <div className='page-body'>
            <ViewVideoPackageComponent />
        </div>
    );
}